import React, {useContext, useEffect, useRef, useState} from "react";
import AppConfigContext from "../../contexts/AppConfigContext";
import {ServiceContext} from "../../contexts/ServicesContext";
import {AppFunctionsContext} from "../../contexts/AppFunctionsContext";
import {checkLogin} from "../../helpers";
import {useFocusEffect} from "@react-navigation/native";
import initWebPush from "../../src/pushScripts";
import {Colors} from "../../themes/baran/colors";
import {MenuDetails} from "../../rest/jtmc/models/MenuDetails";
import {OrderContext} from "../../contexts/OrderContext";
import {storageFunctions} from "../../storage";
import {replace} from "../../refrences/RootNavigation";

export default function MenuScreenFunction(props: { children: any, onMenuDetailsChange: (m: MenuDetails|undefined)=>void }) {
    const servicesContext = useContext(ServiceContext);
    const appContext = useContext(AppConfigContext);
    const appFunctions = useContext(AppFunctionsContext);
    const [menuDetails, setMenuDetails] = useState<MenuDetails>();

    checkLogin().then(loggedIn => {
        // ToDo: Removing force login
        // if (!loggedIn)
        //     appFunctions.appNavigator.toLoginPage()
    });

    /////////////////////////// INITIATING PUSH SCRIPTS
    useEffect(() => {
        checkLogin().then(loggedIn => {
            if (loggedIn)
                initWebPush();
        });
    }, []);

    useFocusEffect(React.useCallback(() => {
        appFunctions.appFetch.getMenuDetails().then(m => {
            setMenuDetails(m);
            if(m.guestToken != null)
                storageFunctions.saveData("api_key", m.guestToken).then(()=>{
                    initWebPush();
                });
        })
    }, []));

    /////////////////////////// SETUP SERVICES CONTEXT
    useEffect(() => {
        if (menuDetails != null && menuDetails.services != null)
            servicesContext.setServices(menuDetails.services);
        if (menuDetails != null) {
            appContext.setThemeColor(menuDetails.menuColor);
            appContext.setThemeName(menuDetails.themeName);
        }
    }, [menuDetails]);

    useEffect(() => {
        props.onMenuDetailsChange(menuDetails);
    }, [menuDetails]);

    const [selectedCategoryId, setSelectedCategoryId] = useState(0);

    /////////////////////////// SETTING UP MANIFEST
    useEffect(() => {
        if (menuDetails == null)
            return;
        const home = `https://${window.location.hostname}/${appContext.branch}/outside/0?origin=pwa`;
        let myDynamicManifest = {
            "name": menuDetails?.branchInfo.storeName,
            "short_name": menuDetails?.branchInfo.storeName,
            "description": `سفارش آنلاین از ${menuDetails?.branchInfo.storeName}`,
            "start_url": home,
            "scope": home,
            "background_color": Colors.instance(appContext.theme, appContext.color).get("highConBackground"),
            "theme_color": Colors.instance(appContext.theme, appContext.color).get("primaryColor"),
            "display": "standalone",
            "orientation": "portrait",
            "icons": [
                {
                    "src": menuDetails?.branchInfo.storeLogos.logo192,
                    "sizes": "192x192"
                },
                {
                    "src": menuDetails?.branchInfo.storeLogos.logo512,
                    "sizes": "512x512"
                },
                {
                    "src": menuDetails?.branchInfo.storeLogos.logo144,
                    "sizes": "144x144"
                }
            ]
        };
        const stringManifest = JSON.stringify(myDynamicManifest);
        const blob = new Blob([stringManifest], {type: 'application/json'});
        const manifestURL = URL.createObjectURL(blob);
        document.querySelector('#manifest-placeholder')?.setAttribute('href', manifestURL);
        document.querySelectorAll("link[rel~='icon']").forEach(item => {
            item.setAttribute('href', menuDetails.branchInfo.storeLogos.logo144);
        });
    }, [menuDetails]);

    return <>
        {props.children}
        <ActiveOrderMakeAction
            menuDetails={menuDetails}/>
    </>
}

function ActiveOrderMakeAction(props: any) {
    const menuDetails: MenuDetails = props.menuDetails;
    const orderContext = useContext(OrderContext);
    const appConfigContext = useContext(AppConfigContext);
    const appFunctions = useContext(AppFunctionsContext);

    useEffect(() => {
        switch (orderContext.order?.action.action) {
            case "active_order_information_page":
                switch (appConfigContext.orderType) {
                    case "outside":
                    case "table":
                        appFunctions.appNavigator.toOrderProgress(menuDetails);
                        break;
                    case "takeaway":
                        appFunctions.appNavigator.toTakeawayReceipt(menuDetails);
                        break;
                }
                break;
            case "goto_ipg":
                appFunctions.appNavigator.toIPGCompletion();
                break;
            case "show_branch_decline_page":
                break;
            case "show_delivery_decline_page":
                break;
            case "ctc_receipt_form":
                appFunctions.appNavigator.toCTCReceipt();
                break;
        }
    }, [orderContext.order]);

    useEffect(() => {
        if (menuDetails != null)
            orderContext.setOrder(menuDetails.activeOrder);
    }, [menuDetails?.activeOrder]);

    return <></>;
}
